<template>
  <div class="button-container">
    <button
      class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium"
      @click="exportPDF"
      title="PDF"
    >
      <i class="fa w3-large fa-file-pdf w3-text-red"></i>
    </button>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "ExportButton",
  props: ["fileName", "columns", "objects"],
  methods: {
    exportPDF() {
      const doc = new jsPDF("landscape");
      doc.autoTable(this.columns, this.objects, {
        theme: "striped",
        headerStyles: { fillColor: [9, 78, 119] },
        styles: {
          overflow: "linebreak",
        },
      });
      doc.save(this.fileName + ".pdf");
    },
  },
};
</script>

<style scoped>
.button-container {
  margin-left: 20px;
}

.button-container button {
  height: 100%;
  padding-top: 0%;
  padding-bottom: 0%;
}
</style>
